// Code generated - EDITING IS FUTILE. DO NOT EDIT.
//
// Generated by:
//     public/app/plugins/gen.go
// Using jennies:
//     TSTypesJenny
//     PluginTsTypesJenny
//
// Run 'make gen-cue' from repository root to regenerate.

import * as common from '@grafana/schema';

export interface GaugePanelEffects {
  barGlow?: boolean;
  centerGlow?: boolean;
  rounded?: boolean;
  spotlight?: boolean;
}

export const defaultGaugePanelEffects: Partial<GaugePanelEffects> = {
  barGlow: false,
  centerGlow: false,
  rounded: false,
  spotlight: false,
};

export interface Options extends common.SingleStatBaseOptions {
  barWidthFactor: number;
  effects: GaugePanelEffects;
  gradient: ('none' | 'auto');
  segmentCount: number;
  segmentSpacing: number;
  shape: ('circle' | 'gauge');
  showThresholdLabels: boolean;
  showThresholdMarkers: boolean;
  sparkline?: boolean;
}

export const defaultOptions: Partial<Options> = {
  barWidthFactor: 0.5,
  effects: {},
  gradient: 'auto',
  segmentCount: 1,
  segmentSpacing: 0.3,
  shape: 'gauge',
  showThresholdLabels: false,
  showThresholdMarkers: true,
  sparkline: true,
};
